export const transitionStreamName = {
  intro: 'intro',
  outro: 'outro',
};

export const boostNextPlayButtonDesktopWidth = 37;
export const boostNextPlayButtonMobileWidth = 32;
